<template>
  <div class="imgF">
    <!-- <img src="@/assets/WXme.jpg" class="query" /> -->
    <el-image :src="imgSrc" lazy></el-image>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
      name: "Public",
      data() {
        return {
          imgSrc: require('@/assets/WXme.fa3711.jpg')
        }
      }
  }
</script>

<style scoped>
  .query{
    width:100%;
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Public.vue